import { Injectable } from '@angular/core';
import { AuthenticationService } from '@tylertech/cj-jpp-ui-core/authentication';
import { map, Observable, ReplaySubject } from 'rxjs';
import { OktaAuthStateService } from "@okta/okta-angular";
import { InstanceManagerService } from "./instance-manager.service";
import { Instance } from "@tylertech/cj-jpp-tims-angular-sdk";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private rolesSubject$: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  private userSubject$: ReplaySubject<any | undefined> = new ReplaySubject<any | undefined>(1);

  constructor(private authService: AuthenticationService,
              private authStateService: OktaAuthStateService,
              private instanceManagerService: InstanceManagerService) {

    this.authStateService.authState$.subscribe(async a => {
      await this.onAuthenticated(a.isAuthenticated ?? false);
    });

    this.instanceManagerService.instances$.subscribe(i => this.onInstancesChanged(i));
  }

  public get hasAuditRole$(): Observable<boolean> {
    return this.rolesSubject$.pipe(map(r => r.includes('ncic-audit')));
  }

  public get hasDeviceAdminRole$(): Observable<boolean> {
    return this.rolesSubject$.pipe(map(r => r.includes('ncic-device-admin')));
  }

  public get hasGeneralAdminRole$(): Observable<boolean> {
    return this.rolesSubject$.pipe(map(r => r.includes('general-admin')));
  }

  public get hasInstanceAdminRole$(): Observable<boolean> {
    return this.rolesSubject$.pipe(map(r => r.includes('instance-admin')));
  }

  public get hasQueryRole$(): Observable<boolean> {
    return this.rolesSubject$.pipe(map(r => r.includes('ncic-query')));
  }

  public get roles$(): Observable<string[]> { return this.rolesSubject$.asObservable() }
  public get user$(): Observable<any> { return this.userSubject$.asObservable() }

  private async onAuthenticated(isAuthenticated: boolean) {
    if (isAuthenticated) {
      try {
        const user = await this.authService.getUser();
        this.userSubject$.next(user);
      } catch (err) {
        console.error(err)
        this.userSubject$.next(undefined);
      }
    } else { this.userSubject$.next(undefined) }
  }

  private onInstancesChanged(instances: Instance[]) {
    const instanceId = this.instanceManagerService.instanceIdSnapshot;
    const roles = instances.find(i => i.instanceId === instanceId)?.roles ?? [];
    this.rolesSubject$.next(roles);
  }
}